import { Oficina } from '../../model/oficina/oficina';

/**
 * Puerto Abstracto: OficinaRepository
 * 
 * Define el contrato para gestión de oficinas.
 * Migrado desde: FilterProgramarServiciosViewImpl.java
 * 
 * Arquitectura Hexagonal:
 * - Este puerto está en el dominio
 * - HttpOficinaRepository (adaptador) lo implementa en infraestructura
 * 
 * @author Sura - Migración GWT a Spring Boot
 */
export abstract class OficinaRepository {

  /**
   * Obtiene las oficinas activas.
   * 
   * @returns Lista de oficinas activas
   */
  abstract obtenerOficinas(): Promise<Oficina[]>;
}
